export default __webpack_public_path__ + "static/media/signup.088219a7.svg";